
import { Component, Inject, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import State from './state';
import { Marker } from './types';

@Component({
  components: {
    vSelect,
  },
})
export default class MarkerAddModal extends Vue {
  @Inject()
  readonly state!: State;

  marker: Marker | null = null;

  get canSave(): boolean {
    return !!this.marker && !!this.marker.label;
  }

  get cellId(): number | null {
    return this.marker?.cellId ?? null;
  }

  set cellId(value: number | null) {
    if (!this.marker) {
      return;
    }

    if (value !== null) {
      this.$set(this.marker, 'cellId', value);//set and make reactive
    } else {
      this.$delete(this.marker, 'cellId');//delete reactively
    }
  }

  mounted(): void {
    this.state.cellStore.loadIfAbsent();
  }

  public open(marker: Marker) {
    this.marker = marker;
    $(this.$refs.modal!).modal('show');
    $(this.$refs.modal!).on('shown.bs.modal', () => {
      (this.$refs.input as HTMLInputElement).focus();
    });
  }

  public dismiss() {
    $(this.$refs.modal!).modal('hide');
    this.marker = null;
  }

  save(): void {
    if (!this.canSave) {
      return;
    }

    this.$emit('save', this.marker);
  }
}
